<template>
    <div class="Powerexecl">
        <div style="width: 280px;padding: 0 20px">
            <div style="height: 750px;">
                <div class="tree-wrap">
                    <me-tree
                        ref="myTree"
                        :treeData="data"
                        :treeLoading="treeLoading"
                        :treeToolBar="false"
                        :defaultProps="defaultProps"
                        :nodeKey="'point_id'"
                        :showCheckbox="true"
                        :cascadingVar="true"
                        :defaultExpandAll="false"
                        :checkStrictly.sync="checkStrictly"
                        :isCheckClick="true"
                        :showStretch="false"
                        :title="treeTitle"
                        :defaultCheckKeys="defaultCheckKeys"
                        :defaultExpandedKeys="defaultExpandedKeys"
                        @handleCheckBoxClick="handleTreeNodeClick"
                    ></me-tree>
                </div>
            </div>
        </div>
        <div
            class="leader-tab power-tab right_container"
            :style="{ width: width }"
        >
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="日报" name="day"></el-tab-pane>
                <el-tab-pane label="月报" name="month"></el-tab-pane>
                <el-tab-pane label="年报" name="year"></el-tab-pane>
                <!-- <el-tab-pane label="自定义" name="custom"></el-tab-pane> -->
            </el-tabs>
            <div class="search_cont">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    class="leader-style-form leader-form-inner-tab-inline"
                >
                    <el-form-item label="时间" style="float:left">
                        <el-date-picker
                            v-model="time"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'day'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="time"
                            type="month"
                            :clearable="false"
                            placeholder="选择月"
                            value-format="yyyy-MM"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'month'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="time"
                            type="year"
                            placeholder="选择年"
                            format="yyyy"
                            value-format="yyyy"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'year'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="start_show_day"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'custom'"
                        ></el-date-picker>
                        <el-date-picker
                            v-model="end_show_day"
                            align="right"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="handleTimeChange"
                            v-show="tabVal === 'custom'"
                        ></el-date-picker>
                        <template v-if="tabVal != 'custom'">
                            <el-button
                                size="medium"
                                @click="forwardTimeClick"
                                style="margin-left:10px"
                            >
                                上一{{
                                    tabVal === 'day'
                                        ? '日'
                                        : tabVal === 'month'
                                        ? '月'
                                        : '年'
                                }}
                            </el-button>
                            <el-button
                                size="medium"
                                :disabled="nextTimeDisabled"
                                @click="nextTimeClick"
                            >
                                下一{{
                                    tabVal === 'day'
                                        ? '日'
                                        : tabVal === 'month'
                                        ? '月'
                                        : '年'
                                }}
                                <!-- <i class="el-icon-caret-right"></i> -->
                            </el-button></template
                        >
                    </el-form-item>
                    <div
                        class="btn-wrap"
                        style="float:right;margin-right:10px;"
                    >
                        <el-button
                            type="warning"
                            size="medium"
                            @click="handleSearchReport"
                            >查询</el-button
                        >
                        <el-button
                            type="primary"
                            size="medium"
                            @click="handleExport"
                            >导出</el-button
                        >
                    </div>
                </el-form>
            </div>
            <div class="table_cont-wrap">
                <div
                    class="leader-title"
                    style="margin: 0 0 20px 0;color: white"
                >
                    {{
                        tabVal === 'day'
                            ? '日报(单位:kWh)'
                            : tabVal === 'month'
                            ? '月报(单位:kWh)'
                            : tabVal === 'year'
                            ? '年报(单位:kWh)'
                            : '自定义(单位:kWh)'
                    }}
                </div>
                <div class="table-wrap-n" v-loading="tableLoading">
                    <div v-if="tabVal === 'day'">
                        <el-table
                            border
                            class="leader-style-table"
                            :data="dayTableDatas"
                        >
                            <el-table-column
                                align="center"
                                label="序号"
                                width="50"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                label="名称"
                                width="300"
                                property="point_name"
                                v-if="selectTypeId == '0'"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                label="名称"
                                width="300"
                                property="target_unit_name"
                                v-if="selectTypeId == '10'"
                            ></el-table-column>
                            <template v-for="(item, index) in dayHeaders">
                                <el-table-column
                                    align="center"
                                    :label="item.time_key"
                                >
                                    <el-table-column
                                        align="center"
                                        :property="item.active_power_key"
                                        label="有功"
                                    ></el-table-column>
                                    <!-- <el-table-column
                                        align="center"
                                        :property="item.reactive_power_key"
                                        label="无功"
                                    ></el-table-column> -->
                                </el-table-column>
                            </template>
                        </el-table>
                    </div>
                    <div v-else-if="tabVal === 'month' || tabVal === 'year'">
                        <el-table
                            border
                            class="leader-style-table"
                            :data="yearMonthDatas"
                        >
                            <el-table-column
                                align="center"
                                label="序号"
                                width="50"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                label="名称"
                                width="300"
                                property="point_name"
                                v-if="selectTypeId == '0'"
                            ></el-table-column>
                            <el-table-column
                                align="center"
                                label="名称"
                                width="300"
                                v-if="selectTypeId == '10'"
                                property="target_unit_name"
                            ></el-table-column>
                            <template v-for="(item, index) in yearMonthHeaders">
                                <el-table-column
                                    align="center"
                                    :label="item.time_key"
                                >
                                    <el-table-column
                                        align="center"
                                        :property="item.key_10"
                                        label="尖"
                                    ></el-table-column>
                                    <el-table-column
                                        align="center"
                                        :property="item.key_20"
                                        label="峰"
                                    ></el-table-column>
                                    <el-table-column
                                        align="center"
                                        :property="item.key_30"
                                        label="平"
                                    ></el-table-column>
                                    <el-table-column
                                        align="center"
                                        :property="item.key_40"
                                        label="谷"
                                    ></el-table-column>
                                    <el-table-column
                                        align="center"
                                        :property="item.active_power_key"
                                        label="总"
                                    ></el-table-column>
                                    <el-table-column
                                        align="center"
                                        :property="item.reactive_power_key"
                                        label="无功"
                                    ></el-table-column>
                                </el-table-column>
                            </template>
                        </el-table>
                    </div>
                    <div v-else-if="tabVal == 'custom'">
                        <el-table
                            border
                            class="leader-style-table"
                            :data="customDatas"
                            style="background: #0f1e3c"
                        >
                            <el-table-column
                                align="center"
                                label="序号"
                                width="50"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                                label="名称"
                                width="300"
                                property="point_name"
                            ></el-table-column>
                            <el-table-column
                                v-for="(item, index) in customHeaders"
                                :key="index"
                                align="center"
                                :label="item.head_date"
                                width="150"
                                :property="item.head_power"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from '@/comon/components/tree.vue';
import Collapes from '@/comon/components/collapse-block.vue';
import moment from 'moment';
import * as api from '@/http/api.js';
export default {
    components: {
        'me-tree': Tree,
        'me-collapes': Collapes,
    },
    filters: {
        // 2. 局部过滤器
        floatFormat(value) {
            return parseInt(value * 100) / 100;
        },
    },
    data() {
        return {
            tabVal: 'day',
            time: '',
            start_show_day: '',
            end_show_day: '',
            selectType: '采集点',
            selectTypeId: '0',
            treeTitle: "采集点选择",
            points: [
                {
                    root_point_id: '0', // 采集点
                    root_name: '采集点',
                },
                {
                    root_point_id: '10', // 部门
                    root_name: '部门',
                },
            ],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            dayHeaders: [],
            dayTableDatas: [],
            // 头部
            yearMonthHeaders: [],
            // 数据
            yearMonthDatas: [],
            customHeaders: [],
            customDatas: [],
            nextTimeDisabled: false,
            todayY: '',
            todayM: '',
            todayD: '',
            data: [],
            treeLoading: false,
            defaultProps: {
                children: 'childList',
                label: 'point_name',
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            defaultExpandedKeys: [],
            nodeKey: 'point_id',
            tableData: {},
            tableLoading: false,
            systemDate: {},
            width: 'calc(100% - 320px)',
        };
    },
    created() {
        this.getSysDate('day');
        this.todayY = this.getTimeValue('year');
        this.todayM = this.getTimeValue('month');
        this.todayD = this.getTimeValue('day');
        this.nextTimeDisabled = true;
    },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate1().then((res) => {
                if (res) {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                    this.getUnitPointList();
                }
            });
        },
        // 类别切换
        toggleTab(type) {
            this.selectTypeId = type;
            if (type == '0') {
                this.getUnitPointList();
            } else {
                this.getTargetUnitList();
            }
            if (type == '0') {
                this.title = '采集点选择';
            } else if (type == '10') {
                this.title = '部门选择';
            }
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function(obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === '1') {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === '0') {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                } else {
                    obj.disabled = false;
                    resultArr.push(obj.point_id);
                    // if (!firstPoint.point_id) {
                    //     firstPoint = obj;
                    // }
                }
                // obj.disabled = false;
                // resultArr.push(obj.point_id);
                // if (!firstPoint.point_id) {
                //     firstPoint = obj;
                // }
                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                },
            };
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            this.treeLoading = true;
            api.getCommonPointList({point_class_id: '1658026900632879104'}).then((res) => {
                if (res) {
                    this.data = res.bus_json;
                    let formatData = this.tickMenuIdFilter().filter(
                        res.bus_json
                    );
                    if(res.bus_json && res.bus_json.length && res.bus_json[0].childList && res.bus_json[0].childList.length){
                        this.defaultExpandedKeys = this.defaultCheckKeys = [res.bus_json[0].childList[0].point_id];
                        this.$nextTick(() => {
                            this.$refs.myTree.handleCheckBoxClick(res.bus_json[0].childList[0]);
                        });
                    }
                    if(this.defaultCheckKeys.length) this.getDayData();
                    // this.data = res.bus_json;
                    // let formatData = this.tickMenuIdFilter().filter(
                    //     res.bus_json
                    // );
                    // this.defaultCheckKeys = [formatData.firstPoint.point_id];
                    // this.$nextTick(() => {
                    //     // console.log(this.$refs.myTree);
                    //     this.$refs.myTree.handleCheckBoxClick(formatData);
                    // });
                    // this.getDayData();
                }
                this.treeLoading = false;
            });
        },
        // 获取部门信息
        getTargetUnitList() {
            api.getTargetUnitList().then((res) => {
                if (res) {
                    this.data = res.bus_json;
                    this.transFormerData(this.data);

                    this.defaultCheckKeys = [this.data[0].point_id];
                    this.$nextTick(() => {
                        this.$refs.myTree.handleCheckBoxClick(this.data[0]);
                    });
                    // 调接口
                    this.getTargetUnitDayData();
                }
            });
        },
        transFormerData(datas) {
            datas.forEach((item) => {
                item['point_id'] = item.target_unit_id;
                item['point_name'] = item.target_unit_name;
                if (item.childList && item.childList.length > 0) {
                    this.transFormerData(item.childList);
                }
            });
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 日月年tab切换回调事件
         */
        handleTabClick(tab, event) {
            this.nextTimeDisabled = true;
            if (tab.name === 'day') {
                this.time = this.systemDate.sysdate;
                if (this.selectTypeId == '0') {
                    this.getDayData();
                } else {
                    this.getTargetUnitDayData();
                }
            } else if (tab.name === 'month') {
                this.time = this.systemDate.sysdate3;
                if (this.selectTypeId == '0') {
                    this.getMonthData();
                } else {
                    this.getTargetUnitMonthData();
                }
            } else if (tab.name === 'year') {
                this.time = this.systemDate.sysdate4;
                if (this.selectTypeId == '0') {
                    this.getYearData();
                } else {
                    this.getTargetUnitYearData();
                }
            } else {
                // 自定义
                // this.start_show_day = this.systemDate.sysdate;
                // this.end_show_day = this.systemDate.sysdate;
                this.start_show_day = moment(new Date(this.systemDate.sysdate))
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
                this.end_show_day = moment(new Date(this.systemDate.sysdate))
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
                this.getCustomData();
            }
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === 'year') {
                return date.getFullYear() + '';
            } else if (type === 'month') {
                return date.getFullYear() + '-' + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    '-' +
                    (date.getMonth() + 1) +
                    '-' +
                    date.getDate()
                );
            }
        },
        /**
         * 下一日、下一月、下一年点击
         */

        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === 'day') {
                this.time = moment(new Date(this.time))
                    .add(1, 'days')
                    .format('YYYY-MM-DD');
            } else if (this.tabVal === 'month') {
                this.time = moment(new Date(this.time))
                    .add(1, 'months')
                    .format('YYYY-MM');
            } else {
                this.time = moment(new Date(this.time))
                    .add(1, 'years')
                    .format('YYYY');
            }
            // 获取报告列表
            this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (
                (this.tabVal === 'day' && selectTime >= todayD) ||
                (this.tabVal === 'month' && selectTime >= todayM) ||
                (this.tabVal === 'year' && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === 'day') {
                this.time = moment(new Date(this.time))
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
            } else if (this.tabVal === 'month') {
                this.time = moment(new Date(this.time))
                    .subtract(1, 'months')
                    .format('YYYY-MM');
            } else {
                this.time = moment(new Date(this.time))
                    .subtract(1, 'years')
                    .format('YYYY');
            }
            // 获取报告列表
            this.handleSearchReport();
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            params = {
                point_ids: point_ids,
                show_day: this.time,
            };
            this.tableLoading = true;
            api.getDayDataGf(params).then((res) => {
                if (res) {
                    this.dayTableDatas = res.bus_json.returnList;
                    this.dayHeaders = res.bus_json.headList;
                }
                this.tableLoading = false;
            });
        },
        // 获取部门日报
        getTargetUnitDayData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            params = {
                target_unit_ids: point_ids,
                show_day: this.time,
            };
            this.tableLoading = true;
            api.getTargetUnitDayData(params).then((res) => {
                if (res) {
                    this.dayTableDatas = res.bus_json.returnList;
                    this.dayHeaders = res.bus_json.headList;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_month: this.time,
            };
            api.getMonthDataGf(params).then((res) => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.yearMonthHeaders = res.bus_json.headList;
                    this.yearMonthDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
            });
        },
        // 获取部门月报
        getTargetUnitMonthData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            this.tableLoading = true;
            params = {
                target_unit_ids: point_ids,
                show_month: this.time,
            };
            api.getTargetUnitMonthData(params).then((res) => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.yearMonthHeaders = res.bus_json.headList;
                    this.yearMonthDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
            });
        },
        /**
         * 获取年报列表
         */
        getYearData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                show_year: this.time,
            };
            api.getYearDataGf(params).then((res) => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.yearMonthHeaders = res.bus_json.headList;
                    this.yearMonthDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
            });
        },
        getTargetUnitYearData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            this.tableLoading = true;
            params = {
                target_unit_ids: point_ids,
                show_year: this.time,
            };
            api.getTargetUnitYearData(params).then((res) => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.yearMonthHeaders = res.bus_json.headList;
                    this.yearMonthDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
            });
        },
        // 获取自定义
        getCustomData() {
            let params = {};
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            const start = moment(this.start_show_day, 'YYYY-MM-DD');
            const end = moment(this.end_show_day, 'YYYY-MM-DD');
            const a = end.diff(start, 'days');
            if (parseInt(a) < 0) {
                this.$message({
                    message: '结束时间不能小于开始时间',
                    type: 'warning',
                });
                return;
            }
            let point_ids = this.defaultCheckKeys.join(',');
            this.tableLoading = true;
            params = {
                point_ids: point_ids,
                start_show_day: this.start_show_day,
                end_show_day: this.end_show_day,
            };
            api.getMonthData2(params).then((res) => {
                if (res) {
                    // this.tableData = res.bus_json;
                    this.customHeaders = res.bus_json.headList;
                    this.customDatas = res.bus_json.returnList;
                }
                this.tableLoading = false;
                this.$forceUpdate();
            });
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            if (this.tabVal === 'day') {
                if (this.selectTypeId == '0') {
                    this.getDayData();
                } else {
                    this.getTargetUnitDayData();
                }
            } else if (this.tabVal === 'month') {
                if (this.selectTypeId == '0') {
                    this.getMonthData();
                } else {
                    this.getTargetUnitMonthData();
                }
            } else if (this.tabVal === 'year') {
                if (this.selectTypeId == '0') {
                    this.getYearData();
                } else {
                    this.getTargetUnitYearData();
                }
            } else {
                // 自定义
                if (this.selectTypeId == '0') {
                    this.getCustomData();
                } else {
                    // this.getTargetUnitYearData();
                }
            }
        },
        handleExport() {
            if (!this.defaultCheckKeys.length) {
                this.$message({
                    message: '请选择节点后进行查询操作！',
                    type: 'warning',
                });
                return;
            }
            if (this.selectTypeId == '0') {
                if (this.tabVal == 'custom') {
                    this.handleExportExlCustom();
                } else {
                    this.handleExportExl();
                }
            } else {
                this.handleExportUnitExcel();
            }
        },
        /**
         * 导出excel表格
         */
        handleExportExl() {
            const loading = this.$loading({
                lock: true,
                text: '下载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            let show_type =
                this.tabVal === 'day'
                    ? '1'
                    : this.tabVal === 'month'
                    ? '2'
                    : '3';
            api.getExcelGf({
                show_time: this.time,
                point_ids: point_ids,
                show_type: show_type,
            }).then((res) => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.tabVal === 'day'
                            ? this.time + '日报' + '.xlsx'
                            : this.tabVal === 'month'
                            ? this.time + '月报' + '.xlsx'
                            : this.time + '年报' + '.xlsx';
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent('MouseEvents');
                        evt.initEvent('click', false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: '下载成功！',
                        type: 'success',
                    });
                }
                loading.close();
            });
        },
        handleExportExlCustom() {
            const start = moment(this.start_show_day, 'YYYY-MM-DD');
            const end = moment(this.end_show_day, 'YYYY-MM-DD');
            let days = end.diff(start, 'seconds') / 60 / 60 / 24;
            console.log('days: ', days);
            if (parseInt(days) >= 60) {
                this.$message({
                    message: '间隔时间不能超过60天',
                    type: 'warning',
                });
                return;
            }
            const a = end.diff(start, 'days');
            if (parseInt(a) < 0) {
                this.$message({
                    message: '结束时间不能小于开始时间',
                    type: 'warning',
                });
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '下载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let point_ids = this.defaultCheckKeys.join(',');
            api.getExcelCustom({
                start_show_day: this.start_show_day,
                end_show_day: this.end_show_day,
                point_ids: point_ids,
            }).then((res) => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.start_show_day +
                        '-' +
                        this.end_show_day +
                        '报表' +
                        '.xlsx';
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent('MouseEvents');
                        evt.initEvent('click', false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: '下载成功！',
                        type: 'success',
                    });
                }
                loading.close();
            });
        },
        // 部门导出
        handleExportUnitExcel() {
            const loading = this.$loading({
                lock: true,
                text: '下载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let point_ids = this.defaultCheckKeys.join(',') + ',';
            let show_type =
                this.tabVal === 'day'
                    ? '1'
                    : this.tabVal === 'month'
                    ? '2'
                    : '3';
            api.getTargetUnitExcel({
                show_time: this.time,
                target_unit_ids: point_ids,
                show_type: show_type,
            }).then((res) => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName =
                        this.tabVal === 'day'
                            ? this.time + '日报' + '.xlsx'
                            : this.tabVal === 'month'
                            ? this.time + '月报' + '.xlsx'
                            : this.time + '年报' + '.xlsx';
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent('MouseEvents');
                        evt.initEvent('click', false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: '下载成功！',
                        type: 'success',
                    });
                }
                loading.close();
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? 'calc(100% - 320px)' : 'calc(100% - 56px)';
        },
    },
};
</script>
<style lang="scss">
//@import "../../../../assets/css/date-picker";

.Powerexecl {
    width: 100%;
    height: 85%;
    display: flex;
    flex-direction: row;
    .tree-wrap {
        height: 100%;
        // overflow: hidden;
        height: calc(100% - 10px);
        box-sizing: border-box;
    }
    .right_container {
        .el-tabs--card {
            margin: 0;
        }
        .search_cont {
            width: 100%;
            margin: 15px 0 20px 0;
            .form {
                display: flex;
                justify-content: space-between;
                .button-group {
                    display: inline-block;
                    margin-left: 20px;
                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                        border-color: #ebeef5;
                    }
                }
            }
        }
        .table_cont-wrap {
            width: 100%;
            padding: 0;
            box-sizing: border-box;
            // overflow: hidden;
            .green {
                height: 12px;
                width: 5px;
                background: #0089f1;
                margin: 10px;
                float: left;
            }
            width: 100%;
            font-size: 16px;
            text-align: left;
            line-height: 32px;
        }
        .table-wrap-n {
            font-size: 14px;
            width: 100%;
            padding: 30px 30px 0 30px;
            box-sizing: border-box;
            height: 500px;
            margin: 0;
            position: relative;
            // background: url('../../../../assets/image/leaderpage/table-bg.png')
            //     no-repeat;
            background-size: 100% 100%;
            // overflow: auto;
            .table-header {
                width: 100%;
                display: flex;
                flex-direction: row;

                color: #fff;
                height: 50px;
                line-height: 50px;
                // border-top: 1px solid #ededed;
                // border-left: 1px solid #ededee;
            }
            .table-name {
                min-width: 200px !important;
                box-sizing: border-box;
            }
            .table-header-colum {
                flex: 1;
                // border-right: 1px solid #ededed;
                // border-bottom: 1px solid #ededed;
                // background: #f8f8f8;
                background: rgba(38, 77, 132, 0.6) !important;
                text-align: center;
                min-width: 80px;
                padding: 3px 0;
            }
            .table-row {
                display: flex;
                flex-direction: row;
                min-width: 100%;
                color: #fff;

                // border-left: 1px solid #ededee;
                .table-row-item {
                    flex: 1;
                    // border-right: 1px solid #ededed;
                    // border-bottom: 1px solid #ededed;
                    text-align: center;
                    min-width: 80px;
                    // padding: 3.5px 0;
                }
            }
            .table-row:nth-child(2n) .table-row-item {
                background: transparent !important;
                color: #ffffff;
                height: 50px;
                line-height: 50px;
            }

            .table-row:nth-child(2n + 1) .table-row-item {
                background: rgba(38, 77, 132, 0.6) !important;
                color: #ffffff;
                height: 50px;
                line-height: 50px;
            }
            .table-nodata {
                // border: 1px solid #ededed;
                text-align: center;
                // color: #999;
                color: #fff;
            }
        }
    }
    .el-tabs__item {
        color: #fff;
    }
    .el-tabs--card {
        margin: 0;
    }
    .is-top .is-active {
        color: #56fcff !important;
    }
    .power-tab {
        margin: 4px 0 0 0;
    }

 
.el-table__body-wrapper{overflow: auto!important;height: 450px!important;}
.leader-style-table{height: 100%!important;}
.table-wrap-n{height:576px!important;}

}
</style>
